import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3h-6.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H3v18h18V3zm-9 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"
}), 'AssignmentReturnSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AssignmentReturnSharp.js
// module id = 2158
// module chunks = 2